export default class APIRequest {

    static set = async (endpoint, method, body) => {
  
      // console.log(localStorage.token)
  
      let token = localStorage.token;
      let request = {
        method: method,
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body)
      };
  
      let response = await fetch(`${process.env.REACT_APP_NEO_DIAGNOSIS_API_V3_PREDICT}/` + endpoint, request);

      console.log("respon", response.json())
      if (response.ok) {
        return response.json();
      }
  
      let error = await response.json();
      console.log(error.msg)
  
      if (
        error.msg === 'JWT_EXPIRED' ||
        error.msg === 'NO_TOKEN_PROVIDED' ||
        error.msg === 'INVALID_TOKEN' ||
        error.msg === 'BAD_TOKEN_FORMAT' ||
        error.msg === 'NO_SECRET_DEFINED' ||
        error.error_message === 'JWT_MALFORMED' ||
        error.error_message?.msg === 'JWT_MALFORMED' ||
        error.error_message === 'JWT_EXPIRED' ||
        error.code === "SUBSCRIPTION_EXPIRED" ||
        error.code === "JWT_EXPIRED"
      ) {
        localStorage.clear();
        console.log("Token deleted");
        window.location.reload()
      }
      throw error;
    }
  
  
  }
  